import './App.scss'
import { Route, Routes, useNavigate, useLocation } from 'react-router'
import { PvBrHome, PvBrLayout, urlBuilder } from 'previc-dsgov'
import type { PvBrMenuItem } from 'previc-dsgov'
import { useState } from 'react'
import keycloak from './keycloak';
import Home from './components/Home'
// // Rotas Pessoas Jurídicas
import PessoaJuridicaCadastrar from "./views/PessoaJuridica/Cadastrar";
import PessoaJuridicaConsultar from "./views/PessoaJuridica/Consultar";
import PessoaJuridicaManter from "./views/PessoaJuridica/Manter";
import PessoaJuridicaOperacoes from './views/PessoaJuridica/Componentes/Operacoes'

import EfpcCadastrar from "./views/Efpc/Cadastrar";
import EfpcConsultar from "./views/Efpc/Consultar";
import EfpcManter from "./views/Efpc/Manter";
import EfpcAlterar from './views/Efpc/Alterar'

import EfpcOperacoes from './views/Efpc/Componentes/Operacoes'
import OperacaoAutorizacaoEfpc from './views/PessoaJuridica/Componentes/OperacaoAutorizacaoEfpc'
import OperacaoAutorizacaoPlano from './views/Efpc/Componentes/OperacaoAutorizacaoPlano'

import PlanoCadastrar from './views/PlanoBeneficio/Cadastrar'
import PlanoConsultar from './views/PlanoBeneficio/Consultar'
import PlanoManter from './views/PlanoBeneficio/Manter'
import PlanoAlterar from './views/PlanoBeneficio/Alterar'

import ConvenioCadastrar from './views/Convenio/Cadastrar'
import ConvenioManter from './views/Convenio/Manter'

import CtrlDoc from './views/TesteApi/Componentes/ctrlDoc'
import DocumentoCrud from './views/Tabela/Documento/Manter'
import TipoDocumentoPage from './views/Tabela/Documento/TipoDocumentoPage'
import OnlyPdf from './views/Tabela/Documento/OnlyPdf'

import TesteApi from './views/TesteApi/Cadastrar'
import { menuItemsComTestesJson, menuItemsExternoJson, menuItemsJson } from './components/MenuItems'
import { EntidadeContextProvider } from './components/EntidadeContext'

function App() {

  const navigate = useNavigate();
  const location = useLocation();
  const redirectUri = import.meta.env.VITE_APP_KEYCLOAK_REDIRECT_URL;
  const loginLink = urlBuilder.loginBuilder(
    import.meta.env.VITE_APP_KEYCLOAK_URL,
    import.meta.env.VITE_APP_KEYCLOAK_REALM,
    import.meta.env.VITE_APP_KEYCLOAK_CLIENTID,
    redirectUri);
  const logoutLink = urlBuilder.logoutBuilder(
    import.meta.env.VITE_APP_KEYCLOAK_URL,
    import.meta.env.VITE_APP_KEYCLOAK_REALM);

  const [menuItemsComTestes] = useState<PvBrMenuItem[]>(menuItemsComTestesJson);
  const [menuItemsDesenvolvimento] = useState<PvBrMenuItem[]>(menuItemsJson);
  const [menuItemsProducao] = useState<PvBrMenuItem[]>(menuItemsExternoJson);
  const appBase = import.meta.env.VITE_APP_BASE;
  const incluirRotasDeTeste = import.meta.env.VITE_MENU_INCLUIR_ROTAS_DE_TESTE === 'true';
  const ambienteProducao = import.meta.env.VITE_PROD;

  const menuItems = incluirRotasDeTeste ? menuItemsComTestes
            : ambienteProducao ? menuItemsProducao : menuItemsDesenvolvimento;

  return (
    <Routes>
      <Route index element={
        <PvBrHome titulo="CAD PREVIC" subtitulo="Cadastro de Entidades, Planos e Dirigentes" loginLink={loginLink} />
      } />

      <Route path={appBase + "/*"} element={
        <PvBrLayout loginLink={loginLink} navigate={navigate} location={location}
          titulo={'CAD PREVIC'} subtitulo={'Cadastro de Entidades, Planos e Dirigentes'}
          logoutLink={logoutLink} menuItems={menuItems} keycloak={keycloak} redirectUri={redirectUri} >
          <EntidadeContextProvider>
            <Routes>
              <Route index element={<Home />} />
              <Route path="pessoa-juridica-cadastrar" element={<PessoaJuridicaCadastrar />} />
              <Route path="pessoa-juridica-consultar" element={<PessoaJuridicaConsultar />} />
              <Route path="pessoa-juridica-manter" element={<PessoaJuridicaManter />} />

              <Route path="pessoa-juridica-consultar/:tipo" element={<PessoaJuridicaConsultar />} />
              <Route path="pessoa-juridica-operacao-autorizacao-efpc" element={<OperacaoAutorizacaoEfpc />} />

              <Route path="operacao-pessoa-juridica" element={<PessoaJuridicaOperacoes />} />
              <Route path="efpc-cadastrar/:tipo" element={<EfpcCadastrar />} />
              <Route path="efpc-cadastrar" element={<EfpcCadastrar />} />

              <Route path="efpc-consultar" element={<EfpcConsultar />} />
              <Route path="efpc-manter" element={<EfpcManter />} />
              <Route path="efpc-alterar" element={<EfpcAlterar />} />

              <Route path="efpc-consultar/:tipo" element={<EfpcConsultar />} />
              <Route path="operacao-efpc" element={<EfpcOperacoes />} />
              <Route path="efpc-operacao-autorizacao-plano" element={<OperacaoAutorizacaoPlano />} />

              <Route path="plano-cadastrar/:tipo" element={<PlanoCadastrar />} />
              <Route path="plano-manter" element={<PlanoManter />} />
              <Route path="plano-cadastrar" element={<PlanoCadastrar />} />
              <Route path="plano-consultar" element={<PlanoConsultar />} />
              <Route path="plano-alterar" element={<PlanoAlterar />} />

              <Route path="convenio-cadastrar/:tipo" element={<ConvenioCadastrar />} />
              <Route path="convenio-manter" element={<ConvenioManter />} />
              <Route path="convenio-cadastrar" element={<ConvenioCadastrar />} />

              <Route path="ctrldoc" element={<CtrlDoc />} />
              <Route path="onlyPdf" element={<OnlyPdf />} />


              <Route path="tipo-documento-crud" element={<TipoDocumentoPage />} />
              <Route path="documento-crud" element={<DocumentoCrud />} />

              <Route path="teste-api" element={<TesteApi />} />

            </Routes>
          </EntidadeContextProvider>
        </PvBrLayout>
      } />
    </Routes>

  )
}

export default App
